import { useEffect } from 'react'

import { NotificationService } from '@/contentComponents/global/Notification'

import useRepository from './useRepository'

/**
 * 탭이 백그라운드에 있다가 포그라운드로 돌아올 때
 * SSE 연결은 살아있지만 그 사이 놓친 알림이 있을 수 있으므로
 * messaging-api를 호출해 최신 상태로 동기화한다.
 */
const useNotificationSync = () => {
  const notificationService = useRepository(NotificationService)

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        notificationService.fetchNotifications()
        notificationService.fetchUnreadCount()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])
}

export default useNotificationSync
